"use client";
import { Text } from "@zapier/design-system";
import { useAtomValue, useSetAtom } from "jotai";
import {
  canvasAtom,
  isEditDescriptionModalOpenAtom,
  isViewOnlyModeAtom,
  actorsAtomFamily,
  uniqueAppsForAllNodesAtom_SUSPENDS,
  hasZslAtom,
  successfulZapRunsAtom_SUSPENDS,
} from "@zapier/canvas-state";
import classNames from "classnames";
import { Suspense } from "react";

import { SummaryApps } from "../SummaryApps";
import { SummaryActors } from "../SummaryActors";

import styles from "./SummaryPanel.module.css";

function SuspendedSummaryAppsWrapper() {
  const uniqueApps = useAtomValue(uniqueAppsForAllNodesAtom_SUSPENDS);

  if (uniqueApps.length === 0) {
    return null;
  }

  return (
    <div className={styles.navSection}>
      <SummaryApps
        uniqueApps={uniqueApps}
        tooltipPosition="northwest" // so it doesn't get cut off on the left side
      />
    </div>
  );
}

function SummaryAppsWrapper() {
  return (
    <Suspense fallback={null}>
      <SuspendedSummaryAppsWrapper />
    </Suspense>
  );
}

export function SummaryPanel() {
  const canvas = useAtomValue(canvasAtom);
  const setIsEditDescriptionModalOpen = useSetAtom(
    isEditDescriptionModalOpenAtom,
  );
  const isViewOnlyMode = useAtomValue(isViewOnlyModeAtom);
  const hasZsl = useAtomValue(hasZslAtom);

  const buttonText = canvas?.description ? "Edit" : "Add description";

  const actors = useAtomValue(actorsAtomFamily(false));

  return (
    <>
      {!hasZsl && (
        <Suspense fallback={null}>
          <ActivitySection />
        </Suspense>
      )}
      <div className={styles.navSection}>
        <span className={styles.header}>
          <span className={styles.headerChild}>
            <Text type="SmallPrint3">About</Text>
            {!isViewOnlyMode && (
              <button
                onClick={() => setIsEditDescriptionModalOpen(true)}
                className={classNames(styles.descriptionButton, {
                  [styles.editDescriptionButton]: Boolean(canvas?.description),
                })}
              >
                <Text type="SmallPrint2" color="UiPrimaryStrongest">
                  {buttonText}
                </Text>
              </button>
            )}
          </span>
        </span>
        {canvas?.description && (
          <Text type="SmallPrint1" color="GrayWarm10">
            {canvas.description}
          </Text>
        )}
      </div>
      {actors.length > 0 && (
        <div className={styles.navSection}>
          <SummaryActors />
        </div>
      )}
      <SummaryAppsWrapper />
    </>
  );
}

function ActivitySection() {
  const successfulZapRuns = useAtomValue(successfulZapRunsAtom_SUSPENDS);

  return (
    <div className={styles.navSection}>
      <Text type="SmallPrint3">Past 30 days</Text>
      <div className={styles.activityCards}>
        <div className={styles.card}>
          <Text type="SmallPrint1">Zap runs</Text>
          <Text type="Body2">{successfulZapRuns.toLocaleString()}</Text>
        </div>
      </div>
    </div>
  );
}
